module.exports = __webpack_public_path__ + "img/LT.659ae80d.svg";